<template>
  <!-- 

  [ 보더 옵션 / default : 없음 ]
  .border--right
  .border--right

  [ 간격 옵션 / default : 없음 ]
  .spacing--sm
  .spacing--md
  .spacing--lg

  -->

  <header class="header-vertical-type-a border--right">
    <div class="logo-container text--center py--32px border-b--1px border--solid border--gray border--lighten-3">
      <logo class="logo--xs"></logo>
    </div>
    <menu-main
      class="accordion spacing--lg"
      :menus="myMenu"
      :menuClick="menuClick"
      v-click-outside="menuOff"
    ></menu-main>

  </header>

</template>

<script>
import menu from '../js/menu'

export default {
  mixins: [menu],
  components: {
    Logo: () => import('@/component/common/Logo'),
    MenuMain: () => import('@/component/layout/header/common/MenuMain')
  }
}
</script>
